import * as Sentry from '@sentry/browser';
import queryString from 'query-string';
import { useCookies } from 'react-cookie';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export const useCompanyResetPassword = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const requestPasswordResetEmail = async (email: string) => {
    const url = `${backendBasePath}/company/password`;
    let status;
    const result = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, redirect_url: '' }),
    })
      .then((response) => {
        if (response.status === 200) {
          status = 'success';
          return response.json();
        } else if (response.status === 404) {
          status = 'emailNotFound';
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return { status, result };
  };

  const checkTokenExpired = async (params: { reset_password_token: string }): Promise<{ success: boolean }> => {
    const query = queryString.stringify(params);
    const url = `${backendBasePath}/company/validate_reset_password_token?${query}`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const updatePassword = async (password: string, password_confirmation: string, reset_password_token: string) => {
    const url = `${backendBasePath}/company/password`;
    let status;
    const result = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password, password_confirmation, reset_password_token }),
    })
      .then((response) => {
        if (response.status === 200) {
          status = 'success';
          return response.json();
        } else if (response.status === 401) {
          status = 'tokenExpired';
          return response.json();
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return { status, result };
  };

  return {
    requestPasswordResetEmail,
    checkTokenExpired,
    updatePassword,
  };
};
